module.exports = __webpack_public_path__ + "img/new-year.1aaa8a60.jpg";